import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import ProjectListSale from "./ProjectListSale";
import { useLocation } from "react-router-dom";

function ViewProject({ isActive }) {
  const { state } = useLocation();
  const showAlert = useShowAlert();

  const [Project, setProject] = useState("");

  const [status, setStatus] = useState("pending");
  const [isSalesLoading, setIsSalesLoading] = useState(true);
  const [salesData, setSalesData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;
  const projectId = Project?._id;

  const fetchSalesDetails = async (projectId, page = 0) => {
    try {
      setIsSalesLoading(true);
      const response = await AxiosInstance.get(
        `module/project/${projectId}/sale?pageno=${page + 1}&limit=${perPage}`,
      );
      const { results, totalItems, totalPages } = response.data;
      setSalesData(results || []);
      setTotalItems(totalItems || 0);
      setTotalPages(totalPages || 0);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setIsSalesLoading(false);
    }
  };

  useEffect(() => {
    if (status === "pending" && projectId) {
      fetchSalesDetails(projectId);
    }
  }, [status, projectId]);

  useEffect(() => {
    if (!state?.projectId) return;

    const getProject = async () => {
      try {
        const response = await AxiosInstance.get(
          `module/project/${state.projectId}`,
        );

        setProject(response.data.results);
      } catch (error) {
        handleError(error, showAlert);
      }
    };

    getProject();
  }, [state?.projectId]);

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="card radius-10 mb-0 mt-2">
              <div className="row g-0">
                {/* Left Column Controls */}
                <div className="col-md-3 col-lg-2 border-end">
                  <div className="p-3">
                    {[
                      {
                        key: "pending",
                        label: "List Sale",
                        icon: "bi bi-hourglass-split",
                        color: "bg-label-blue",
                      },
                      // {
                      //   key: "inprogress",
                      //   label: "In Progress",
                      //   icon: "bi bi-arrow-repeat",
                      //   color: "bg-label-primary",
                      // },
                      // {
                      //   key: "ready",
                      //   label: "Ready",
                      //   icon: "bi bi-check2-circle",
                      //   color: "bg-label-blue",
                      // },
                      // {
                      //   key: "delivered",
                      //   label: "Delivered",
                      //   icon: "bi bi-truck",
                      //   color: "bg-label-green",
                      // },
                      // {
                      //   key: "cancelled",
                      //   label: "Cancelled",
                      //   icon: "ng ng-ng-delete-icon",
                      //   color: "bg-label-danger",
                      // },
                    ].map((opt) => (
                      <button
                        key={opt.key}
                        className={`btn w-100 text text-start d-flex justify-content-between align-items-center mb-1
                        ${status === opt.key ? opt.color + " text-white" : "text-muted"}`}
                        onClick={() => {
                          setStatus(opt.key);
                        }}
                        style={{
                          border: "none",
                          boxShadow: "none",
                          transition: "background 0.2s ease",
                        }}
                      >
                        <span>
                          <i className={`${opt.icon} me-1`}></i> {opt.label}
                        </span>
                        {/* {getCounts(opt.key) > 0 && (
                          <span className="badge rounded-pill bg-label-project">
                            {getCounts(opt.key)}
                          </span>
                        )} */}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Right Table Container Panel */}
                <div className="col-md-9 col-lg-10">
                  <div className="p-3">
                    <div className="mb-3 shadow-none">
                      <div className="">
                        <h4 className="mb-1">{Project?.name}</h4>

                        {/* <div className="row mt-3">
                          {/* <div className="col-md-4">
                            <strong>Project ID</strong>
                            <div>{Project?._id}</div>
                          </div> 

                          <div className="col-md-4">
                            <strong>Created</strong>
                            <div>
                              {Project?.createdAt
                                ? new Date(Project.createdAt).toLocaleString()
                                : "-"}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <strong>Last Used</strong>
                            <div>
                              {Project?.lastUsedDate
                                ? new Date(
                                    Project.lastUsedDate,
                                  ).toLocaleString()
                                : "-"}
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="border mb-2"></div>
                    <div className="row">
                      <div className="col-12 mb-2">
                        {status === "pending" && (
                          <ProjectListSale
                            isActive={isActive}
                            salesData={salesData}
                            isSalesLoading={isSalesLoading}
                            totalPages={totalPages}
                            perPage={perPage}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewProject;
